import React, { memo, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { Button, CardView, Spacer } from 'design-system';
import AddressVerificationStatusView from 'design-system/AddressVerificationStatusView';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const AddressKYCStatus = ({ address }) => {
    const navigation = useMainStackNavigation();
    const { kycStatus: status } = address || {};
    const openSupport = useCallback(() => {
        navigation.navigateDeprecated('Support', {});
    }, []);
    if (!status || address?.countryIsoCode !== 'GB') {
        return <Spacer h={16}/>;
    }
    return (<CardView withPadding>
      <View style={styles.row}>
        <View style={styles.flex}>
          <Text Text-16>Status</Text>
        </View>
        <AddressVerificationStatusView status={status}/>
      </View>
      {status === 'FAIL' && (<>
          <Spacer h={8}/>
          <Text TextThin-14 Secondary>
            Please get in touch with customer support so that we can get your
            documents approved.
          </Text>
          <Spacer h={16}/>
          <View style={styles.row}>
            <Button hug square brandLight onPress={openSupport} title="Contact support"/>
          </View>
        </>)}
    </CardView>);
};
export default memo(AddressKYCStatus);
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
});
